import { assessmentService } from 'services/assessment.service'
import { inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useAssessmentStore } from 'store/assessment.store'
import useApiError from './useApiError'

export default function useAssessment() {
  const { getAssessment, getAllAssessments } = assessmentService()
  const { assessment, assessments, botoesHeader, loading } =
    storeToRefs(useAssessmentStore())

  const context = inject('context')

  async function initialRequests() {
    loading.value.assessment = true
    try {
      const req = await getAssessment(context?.assessment?.id)
      assessment.value = req
    } catch (error) {
      useApiError(error)
    } finally {
      loading.value.assessment = false
    }
  }

  async function fetchAllAssessments() {
    try {
      const r = await getAllAssessments()
      assessments.value = {
        data: r.results,
        next: r.next,
        loading: { req: false, more: false },
      }
    } catch (error) {
      useApiError(error)
    } finally {
      assessments.value.loading.req = false
    }
  }

  async function loadMoreAssessments() {
    const nextUrl = assessments.value?.next

    if (!nextUrl) return
    assessments.value.loading.more = true

    try {
      const r = await getAllAssessments(nextUrl)
      assessments.value = {
        data: [
          ...(assessments.value.data || []),
          ...(r?.results || []),
        ],
        next: r?.next || null,
        loading: { req: false, more: false },
      }
    } catch (error) {
      useApiError(error)
    } finally {
      assessments.value.loading.more = false
    }
  }

  return {
    initialRequests,
    assessment,
    assessments,
    botoesHeader,
    loading,
    fetchAllAssessments,
    loadMoreAssessments,
  }
}
